import { render, staticRenderFns } from "./ModuleProfile.vue?vue&type=template&id=3da382e4&scoped=true&lang=pug&"
import script from "./ModuleProfile.vue?vue&type=script&lang=js&"
export * from "./ModuleProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModuleProfile.vue?vue&type=style&index=0&id=3da382e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da382e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
